import React from "react";

const ProductSection = ({ data }) => {
  return (
    <div className="flex items-start justify-start">
      <div className="flex flex-row items-center justify-center mt-[2vh] py-2">
        <div className="border-[1px] border-[#acacac] w-[48px]"></div>
        <div className="bg-[#acacac] w-[7px] h-[7px] rounded-full"></div>
        <p className="mx-2 font-outfit font-normal text-[1.9296355vh] text-[#858585]">
          {data}
        </p>
      </div>
    </div>
  );
};

export default ProductSection;
